module.exports = __webpack_public_path__ + "static/media/web.2804fdef.svg";